import React from "react";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import AvatarIcon from "../resources/AvatarIcon";
import { MiniLogo } from "../components/MiniLogo";
import { useTermsAndConditionsStyles } from "../themes/termsAndConditionsStyles";
import { Translate, withLocalize } from "react-localize-redux";

const ProAppTermsAndConditionsPage: React.FC = () => {
  const classes = useTermsAndConditionsStyles();
  const history = useHistory();
  const bProLink = "https://bpro.bwt.com/welcome";

  return (
    <Translate>
      {({ translate }) => (
        <div className={classes.pageContainer}>
          <div className={classes.topBar}>
            <Button
              classes={{ root: classes.buttonRoot }}
              onClick={() => {
                history.push("/");
              }}
            >
              <AvatarIcon color="var(--col-navy-500)" />
            </Button>
            <MiniLogo />
          </div>

          <div className={classes.titleContainer}>
            <div>{translate("proAppTermsAndConditions.titleLine1")}</div>
            <div>{translate("proAppTermsAndConditions.titleLine2")}</div>
            <div>{translate("proAppTermsAndConditions.titleLine3")}</div>
            <div>{translate("proAppTermsAndConditions.bwt")}</div>
          </div>

          <div className={classes.bodyContainer}>
            <div className={classes.paragraph}>
              {translate(
                "proAppTermsAndConditions.paragraph1",
                { bProLink },
                { renderInnerHtml: true }
              )}
            </div>

            <div className={classes.paragraph}>
              {translate("proAppTermsAndConditions.paragraph2")}
            </div>

            <div className={classes.subTitle}>
              <b>{translate("proAppTermsAndConditions.subTitle1")}</b>
            </div>

            <div className={classes.paragraph}>
              {translate(
                "proAppTermsAndConditions.userAccount",
                {},
                { renderInnerHtml: true }
              )}
            </div>
            <div className={classes.paragraph}>
              {translate("proAppTermsAndConditions.1Part2")}
            </div>
            <div className={classes.paragraph}>
              {translate("proAppTermsAndConditions.1Part3")}
            </div>
            <div className={classes.paragraph}>
              {translate("proAppTermsAndConditions.1Part4")}
            </div>
            <div className={classes.paragraph}>
              {translate("proAppTermsAndConditions.1Part5")}
            </div>
            <div className={classes.paragraph}>
              {translate("proAppTermsAndConditions.1Part6")}
            </div>
            <div className={classes.paragraph}>
              {translate("proAppTermsAndConditions.1Part7")}
            </div>

            <div className={classes.paragraph}>
              {translate(
                "proAppTermsAndConditions.intellectualPropertyRights",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div className={classes.paragraph}>
              {translate(
                "proAppTermsAndConditions.contents",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div className={classes.paragraph}>
              {translate(
                "proAppTermsAndConditions.productDescription",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div className={classes.paragraph}>
              {translate(
                "proAppTermsAndConditions.userData",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div className={classes.paragraph}>
              {translate(
                "proAppTermsAndConditions.electronicCommunication",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div className={classes.subTitle}>
              <b>{translate("proAppTermsAndConditions.subTitle2")}</b>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.1")}</b>
              <div>{translate("proAppTermsAndConditions.1Point1")}</div>
              <div>{translate("proAppTermsAndConditions.1Point2")}</div>
              <div>
                {translate(
                  "proAppTermsAndConditions.1Point3",
                  { bProLink },
                  { renderInnerHtml: true }
                )}
              </div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.2")}</b>
              <div>{translate("proAppTermsAndConditions.2Point1")}</div>
              <div>{translate("proAppTermsAndConditions.2Point2")}</div>
              <div>{translate("proAppTermsAndConditions.2Point3")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.3")}</b>
              <div>{translate("proAppTermsAndConditions.3Point1")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.4")}</b>
              <div>{translate("proAppTermsAndConditions.4Point1")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.5")}</b>
              <div>{translate("proAppTermsAndConditions.5Point1")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.6")}</b>
              <div>{translate("proAppTermsAndConditions.6Point1")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.7")}</b>
              <div>{translate("proAppTermsAndConditions.7Point1")}</div>
              <div>{translate("proAppTermsAndConditions.7Point2")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.8")}</b>
              <div>{translate("proAppTermsAndConditions.8Point1")}</div>
              <div>
                <div>{translate("proAppTermsAndConditions.8Point1Part2")}</div>
                <div>{translate("proAppTermsAndConditions.8Point1Part3")}</div>
                <div>{translate("proAppTermsAndConditions.8Point1Part4")}</div>
                <div>{translate("proAppTermsAndConditions.8Point1Part5")}</div>
                <div>{translate("proAppTermsAndConditions.8Point1Part6")}</div>
              </div>
              <div>{translate("proAppTermsAndConditions.8Point2")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.9")}</b>
              <div>{translate("proAppTermsAndConditions.9Point1")}</div>
              <div>{translate("proAppTermsAndConditions.9Point2")}</div>
              <div>{translate("proAppTermsAndConditions.9Point3")}</div>
              <div>
                <div>{translate("proAppTermsAndConditions.bwt")}</div>
                <div>{translate("proAppTermsAndConditions.addressLine1")}</div>
                <div>{translate("proAppTermsAndConditions.addressLine2")}</div>
                <div>{translate("proAppTermsAndConditions.addressLine3")}</div>
                <div>{translate("proAppTermsAndConditions.email")}</div>
              </div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.10")}</b>
              <div>{translate("proAppTermsAndConditions.10Point1")}</div>
              <div>{translate("proAppTermsAndConditions.10Point2")}</div>
              <div>{translate("proAppTermsAndConditions.10Point3")}</div>
              <div>{translate("proAppTermsAndConditions.10Point4")}</div>
              <div>
                {translate("proAppTermsAndConditions.10Point4Paragraph")}
              </div>
              <div>{translate("proAppTermsAndConditions.10Point5")}</div>
              <div>
                {translate("proAppTermsAndConditions.10Point5Paragraph")}
              </div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.11")}</b>
              <div>{translate("proAppTermsAndConditions.11Paragraph1")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.12")}</b>
              <div>{translate("proAppTermsAndConditions.12Paragraph1")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.13")}</b>
              <div>{translate("proAppTermsAndConditions.13Paragraph1")}</div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.14")}</b>
              <div>{translate("proAppTermsAndConditions.14Paragraph1")}</div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gridTemplateRows: "repeat(6, 1fr)",
                  gridAutoFlow: "column",
                  columnGap: "8px",
                }}
              >
                <div>
                  <b>{translate("proAppTermsAndConditions.bwt")}</b>
                </div>
                <div>{translate("proAppTermsAndConditions.addressLine1")}</div>
                <div>{translate("proAppTermsAndConditions.addressLine2")}</div>
                <div>{translate("proAppTermsAndConditions.addressLine3")}</div>
                <div>{translate("proAppTermsAndConditions.email")}</div>
                <div>T.: +43 6232 50110</div>
                <div style={{ gridRow: "2" }}>
                  {translate("proAppTermsAndConditions.companyRegisterNumber", {
                    companyNumber: "FN 96162 s",
                  })}
                </div>
                <div>
                  {translate(
                    "proAppTermsAndConditions.commercialRegisterCourt",
                    { commercialRegisterCourt: "Landesgericht Wels" }
                  )}
                </div>
                <div>
                  {translate("proAppTermsAndConditions.uidNumber", {
                    uidNumber: "ATU23473603",
                  })}
                </div>
                <div>
                  {translate("proAppTermsAndConditions.regulatoryAuthority", {
                    regulatoryAuthority: "BH Vöcklabruck",
                  })}
                </div>
                <div>
                  {translate("proAppTermsAndConditions.austrianEconomic")}
                </div>
              </div>
            </div>

            <div className={classes.list}>
              <b>{translate("proAppTermsAndConditions.15")}</b>
              <div>{translate("proAppTermsAndConditions.15Point1")}</div>
              <div>{translate("proAppTermsAndConditions.15Point2")}</div>
            </div>
          </div>
        </div>
      )}
    </Translate>
  );
};

export default withLocalize(ProAppTermsAndConditionsPage);
